/*
  ag-medicion-cesta.js — registro anónimo de la cesta (Claude, orden de Marco del 14/10/2026; revisiones el 19 y el 20/10).

  Mide cuánto lleva cada carrito al añadir, al cambiar cantidades, al abrir la cesta y al pulsar «Ir a pagar», y
  cuántos ven el aviso del pedido mínimo de 10 € o tocan el botón bloqueado. No cambia nada de lo que ve el cliente:
  solo escucha (el aviso de la cesta y sus animaciones no se tocan).

  Solo con consentimiento de analítica (el mismo estado que expone ag-consent-guard). Envía al Worker
  agranel-medicion una huella del carrito (SHA-256 recortado de su token, no reversible), importe en céntimos,
  nº de artículos, dónde pasó, móvil o escritorio, el canal de llegada de la sesión, el anuncio (utm_content) y la
  ruta de la página de entrada (20/10). Ni nombre, ni correo, ni IP.

  Código, base de datos y consultas: Obisdian_Openclaw/agranel-medicion/ (README.md).
  Para quitarlo: borrar su línea al final de layout/theme.liquid.
*/
(function () {
  'use strict';
  if (window.agMedicion) return;

  var DESTINO = 'https://agranel-medicion.agranelmadrid.workers.dev/e';
  var CLAVE_ORIGEN = 'ag_med_origen';
  var CLAVE_ANUNCIO = 'ag_med_anuncio', CLAVE_ENTRADA = 'ag_med_entrada'; // add 20/10
  var ANADIR = { 'product-form-component': 1, 'ag-core': 1 };
  var RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PRUEBA = 0;
  try { PRUEBA = Shopify.theme.role && Shopify.theme.role !== 'main' ? 1 : 0; } catch (e) {}

  var enviados = 0, MAX_PAGINA = 40, recientes = {}, huellas = {}, ultimaCesta = null;

  function permitido() {
    try { var c = window.agConsentimiento && window.agConsentimiento(); if (c) return !!c.analitica; } catch (e) {}
    try { return !!window.Shopify.customerPrivacy.analyticsProcessingAllowed(); } catch (e) { return false; }
  }

  /* Canal de llegada, calculado en la primera página en la que hay consentimiento. Si ya no es la de entrada
     (el referente es la propia tienda y no hay utm), queda «desconocido». */
  function calcularOrigen() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return 'desconocido'; }
    var s = (q.get('utm_source') || '').toLowerCase();
    var m = (q.get('utm_medium') || '').toLowerCase();
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch (e) {}
    var interno = !!ref && (ref === location.hostname || /(^|\.)agranelmadrid\.com$|\.myshopify\.com$/.test(ref));
    if (q.get('gclid') || q.get('gbraid') || q.get('wbraid') || (s === 'google' && /cpc|paid|ppc/.test(m))) return 'google_ads';
    if (/facebook|instagram|meta|^fb$|^ig$/.test(s) && /paid|cpc|ads/.test(m)) return 'meta_ads';
    if (/instagram|^ig$/.test(s) || /(^|\.)instagram\.com$/.test(ref)) return 'instagram';
    if (/facebook|^fb$/.test(s) || /(^|\.)(facebook|fb)\.com$/.test(ref) || q.get('fbclid')) return 'facebook';
    if (/(^|\.)google\.[a-z.]+$/.test(ref)) return 'google';
    if (/(^|\.)(bing|duckduckgo|yahoo|ecosia)\./.test(ref)) return 'buscador';
    if (s) return 'otro';
    if (interno) return 'desconocido';
    if (ref) return 'enlace';
    return 'directo';
  }
  /* add 20/10 — Anuncio: utm_content de esa misma página, en minúsculas, sin tildes, solo [a-z0-9_-] (lo demás pasa
     a «-»), máx. 60. Si trae «@» o «%40» no se guarda (podría ser un correo). Vacío = sin anuncio. */
  function calcularAnuncio() {
    var a;
    try { a = new URLSearchParams(location.search).get('utm_content') || ''; } catch (e) { return ''; }
    if (/@|%40/i.test(a)) return '';
    a = a.toLowerCase();
    try { a = a.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return a.replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60).replace(/-+$/, '');
  }
  /* add 20/10 — Entrada: ruta de esa misma página, sin query ni fragmento, en minúsculas, máx. 80. De /account,
     /cart, /checkouts, /orders, /invoices, /gift_cards y los proxies de apps (/apps, /a, /community, /tools), también
     tras un id de tienda, solo se guarda hasta ese tramo (detrás puede haber tokens). Con «%40», nada. Vacío = no válida. */
  var RUTA = /^\/[a-z0-9_.%\/-]{0,79}$/;
  var RUTA_PRIVADA = /^((?:\/[a-z]{2}(?:-[a-z]{2})?|\/\d+)?\/(?:account|cart|checkouts|orders|invoices|gift_cards|apps|a|community|tools))\/.*$/;
  function calcularEntrada() {
    var p;
    try { p = String(location.pathname || '/').toLowerCase(); } catch (e) { return ''; }
    if (p.indexOf('%40') !== -1) return '';
    p = p.replace(/\/{2,}/g, '/').replace(RUTA_PRIVADA, '$1');
    if (p.length > 1) p = p.replace(/\/+$/, '');
    p = p.slice(0, 80);
    return RUTA.test(p) ? p : '';
  }
  // Los tres se fijan juntos, una vez por sesión. Si la sesión empezó con el script anterior (ya hay canal),
  // anuncio y entrada quedan vacíos: no serían los de entrada. Misma regla que el canal: si esta página ya no es la de
  // entrada (canal «desconocido»), anuncio y entrada también quedan vacíos en vez de atribuirse a una página interior.
  function fijarOrigen() {
    if (!permitido()) return;
    try {
      if (sessionStorage.getItem(CLAVE_ORIGEN)) return;
      var o = calcularOrigen(), fuera = o === 'desconocido';
      sessionStorage.setItem(CLAVE_ANUNCIO, fuera ? '' : calcularAnuncio());
      sessionStorage.setItem(CLAVE_ENTRADA, fuera ? '' : calcularEntrada());
      sessionStorage.setItem(CLAVE_ORIGEN, o);
    } catch (e) {}
  }
  function leerSesion(k) {
    try { return sessionStorage.getItem(k) || null; } catch (e) { return null; }
  }
  function origen() { return leerSesion(CLAVE_ORIGEN); }

  function lugarPagina() {
    var p = location.pathname, t = '';
    try { t = window.ShopifyAnalytics.meta.page.pageType || ''; } catch (e) {}
    if (/\/cart\/?$/.test(p)) return 'pagina';
    if (t === 'product' || /\/products\//.test(p)) return 'ficha';
    if (t === 'collection' || t === 'blog' || /\/(collections|blogs)\//.test(p)) return 'coleccion';
    if (t === 'home' || p === RAIZ) return 'portada';
    if (t === 'searchresults' || /\/search/.test(p)) return 'busqueda';
    return 'otra';
  }
  function cajonAbierto() {
    var d = document.querySelector('cart-drawer-component dialog');
    return !!(d && d.open);
  }

  function huella(token) {
    if (!token) return Promise.resolve(null);
    if (huellas[token]) return Promise.resolve(huellas[token]);
    try {
      return crypto.subtle.digest('SHA-256', new TextEncoder().encode('agm1:' + token)).then(function (b) {
        var h = Array.prototype.map.call(new Uint8Array(b).slice(0, 8), function (x) {
          return ('0' + x.toString(16)).slice(-2);
        }).join('');
        huellas[token] = h;
        return h;
      }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }

  function leerCesta() {
    return fetch(RAIZ + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || typeof c.total_price !== 'number') return null;
        ultimaCesta = c;
        huella(c.token);
        return c;
      })
      .catch(function () { return null; });
  }

  function mandar(txt) {
    try { if (navigator.sendBeacon && navigator.sendBeacon(DESTINO, new Blob([txt], { type: 'text/plain' }))) return; } catch (e) {}
    try {
      fetch(DESTINO, { method: 'POST', body: txt, keepalive: true, mode: 'no-cors', credentials: 'omit', headers: { 'Content-Type': 'text/plain' } })
        .catch(function () {});
    } catch (e) {}
  }

  // Sin permiso no se pide ni la cesta.
  function puede() { return enviados < MAX_PAGINA && permitido(); }

  function enviar(tipo, cesta, lugar, forzar) {
    if (!forzar && !permitido()) return;
    if (enviados >= MAX_PAGINA) return;
    var total = cesta && typeof cesta.total_price === 'number' ? cesta.total_price : null;
    var n = cesta && typeof cesta.item_count === 'number' ? cesta.item_count : null;
    var clave = tipo + '|' + lugar + '|' + total + '|' + n;
    var ahora = Date.now();
    if (recientes[clave] && ahora - recientes[clave] < 10000) return;
    recientes[clave] = ahora;
    enviados++;
    var token = cesta && cesta.token;
    function cuerpo(h) {
      return JSON.stringify({
        v: 1, t: tipo, c: h || null, tot: total, n: n, l: lugar,
        d: window.innerWidth <= 749 ? 'm' : 'e', o: origen(), pr: tipo === 'prueba' ? 1 : PRUEBA,
        an: leerSesion(CLAVE_ANUNCIO), en: leerSesion(CLAVE_ENTRADA) // add 20/10
      });
    }
    // Al pulsar «Ir a pagar» la página se va: se manda ya, con la huella que haya en caché.
    if (!token || huellas[token]) { mandar(cuerpo(token ? huellas[token] : null)); return; }
    huella(token).then(function (h) { mandar(cuerpo(h)); });
  }

  // 1) Añadidos y cambios de cantidad (mismo evento que usa el aviso de la cesta).
  document.addEventListener('cart:update', function (ev) {
    var d = (ev && ev.detail) || {};
    var data = d.data || {};
    if (data.didError || !puede()) return;
    var tipo = ANADIR[data.source] ? 'anadido' : 'cambio';
    var lugar = cajonAbierto() ? 'cajon' : lugarPagina();
    leerCesta().then(function (c) { if (c) enviar(tipo, c, lugar); });
  });

  // 2) El aviso flotante sale en estado «Te faltan … para el pedido mínimo».
  var aviso = document.getElementById('fstoast');
  function avisoMinimo() { if (puede()) leerCesta().then(function (c) { if (c) enviar('aviso', c, 'aviso'); }); }
  if (aviso) {
    aviso.addEventListener('toggle', function (e) {
      if (e.newState === 'open' && aviso.classList.contains('fstoast--minimo')) avisoMinimo();
    });
    if (typeof aviso.showPopover !== 'function' && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (aviso.classList.contains('is-visible') && aviso.classList.contains('fstoast--minimo')) avisoMinimo();
      }).observe(aviso, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // 3) Se ve la cesta: cajón abierto o página /cart con algo dentro.
  function cestaVista(lugar) { if (puede()) leerCesta().then(function (c) { if (c && c.item_count > 0) enviar('cesta', c, lugar); }); }
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var el = muts[i].target;
        if (el.tagName === 'DIALOG' && el.open && el.closest && el.closest('cart-drawer-component')) { cestaVista('cajon'); return; }
      }
    }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }
  if (/\/cart\/?$/.test(location.pathname)) cestaVista('pagina');

  // 4) Toques en «Pedido mínimo 10 €» (botón desactivado). Se comprueba por coordenadas porque algunos navegadores
  //    no entregan eventos a un botón desactivado; donde no entregan ninguno, no se cuenta (el dato es un mínimo).
  var ultimoToque = 0;
  function toque(ev) {
    var ahora = Date.now();
    if (ahora - ultimoToque < 800) return;
    var p = ev.touches && ev.touches[0] ? ev.touches[0] : ev;
    var x = p.clientX, y = p.clientY;
    if (typeof x !== 'number' || typeof y !== 'number') return;
    var bs = document.querySelectorAll('.cart__checkout-button[disabled]');
    for (var i = 0; i < bs.length; i++) {
      var r = bs[i].getBoundingClientRect();
      if (r.width > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
        ultimoToque = ahora;
        if (!puede()) return;
        var lugar = bs[i].closest('cart-drawer-component') ? 'cajon' : 'pagina';
        leerCesta().then(function (c) { enviar('bloqueado', c, lugar); });
        return;
      }
    }
  }
  ['pointerdown', 'touchstart', 'mousedown'].forEach(function (t) {
    document.addEventListener(t, toque, { capture: true, passive: true });
  });

  // 5) «Ir a pagar» (activo) y pago exprés.
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('.cart__checkout-button');
    if (!b || b.disabled) return;
    var c = ultimaCesta;
    var pie = b.closest('[data-ag-cesta-pie]');
    if (pie) {
      var tot = parseInt(pie.getAttribute('data-ag-total'), 10);
      var n = parseInt(pie.getAttribute('data-ag-items'), 10);
      c = {
        total_price: isNaN(tot) ? (c && c.total_price) : tot,
        item_count: isNaN(n) ? (c && c.item_count) : n,
        token: c && c.token
      };
    }
    enviar('pagar', c, b.closest('cart-drawer-component') ? 'cajon' : 'pagina');
  }, true);
  document.addEventListener('pointerdown', function (ev) {
    var x = ev.target && ev.target.closest && ev.target.closest('shopify-accelerated-checkout-cart, .additional-checkout-buttons');
    if (x) enviar('expres', ultimaCesta, x.closest('cart-drawer-component') ? 'cajon' : 'pagina');
  }, { capture: true, passive: true });

  // 6) Consentimiento: canal, anuncio y entrada se fijan en cuanto se sabe que hay permiso de analítica.
  document.addEventListener('visitorConsentCollected', function (ev) {
    if (ev && ev.detail && ev.detail.analyticsAllowed) setTimeout(fijarOrigen, 0);
  });
  fijarOrigen();
  try {
    if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], fijarOrigen);
  } catch (e) {}

  // Para comprobar a mano desde la consola: agMedicion.probar() manda un evento marcado como prueba.
  // registrar(tipo, lugar): para otras piezas del tema (ag-completar.js manda «sugerido» y «completado»).
  window.agMedicion = {
    version: 3, // 3 = con anuncio y entrada (20/10)
    probar: function () { enviar('prueba', null, 'prueba', true); return 'enviado'; },
    registrar: function (tipo, lugar) {
      if (!puede()) return;
      leerCesta().then(function (c) { enviar(tipo, c, lugar); });
    }
  };
})();
